$(function () {
  if($('#chk_count').length){
      chk_company_name();
      chk_name();
      chk_kana();
      chk_email();
      chk_contents();
      chk_consent();
      chk_count.innerHTML = 6 - $(".chk_ok").length;
      $("input[name='company_name']").on("blur", function () {
        chk_company_name();
        chk_count.innerHTML = 6 - $(".chk_ok").length;
      });
      $("input[name^='name']").on("blur", function () {
        chk_name();
        chk_count.innerHTML = 6 - $(".chk_ok").length;
      });
      $("input[name^='kana']").on("blur", function () {
        chk_kana();
        chk_count.innerHTML = 6 - $(".chk_ok").length;
      });
      $("input[name^='email']").on("blur", function () {
        chk_email();
        chk_count.innerHTML = 6 - $(".chk_ok").length;
      });
      $("textarea[name='contents']").on("blur", function () {
        chk_contents();
        chk_count.innerHTML = 6 - $(".chk_ok").length;
      });
      $("input[name='consent']").on("blur change", function () {
        chk_consent();
        chk_count.innerHTML = 6 - $(".chk_ok").length;
      });
      function chk_company_name(){
        if( $("input[name='company_name']").val() != ""){
          $("span.company_name").addClass('chk_ok bg-success');
          $("span.company_name").removeClass('bg-danger');
          $("span.company_name").text("OK")
        }
        else{
          $("span.company_name").addClass('bg-danger');
          $("span.company_name").removeClass('chk_ok bg-success');
          $("span.company_name").text("必須")
        }
      }
      function chk_name(){
        if( $("input[name='name01']").val() != "" && $("input[name='name02']").val() != ""){
          $("span.name").addClass('chk_ok bg-success');
          $("span.name").removeClass('bg-danger');
          $("span.name").text("OK")
        }
        else{
          $("span.name").addClass('bg-danger');
          $("span.name").removeClass('chk_ok bg-success');
          $("span.name").text("必須")
        }
      }
      function chk_kana(){
        if( $("input[name='kana01']").val() != "" && $("input[name='kana02']").val() != ""){
          $("span.kana").addClass('chk_ok bg-success');
          $("span.kana").removeClass('bg-danger');
          $("span.kana").text("OK")
        }
        else{
          $("span.kana").addClass('bg-danger');
          $("span.kana").removeClass('chk_ok bg-success');
          $("span.kana").text("必須")
        }
      }
      function chk_email(){
        if( $("input[name='email']").val() != "" && $("input[name='email02']").val() != ""){
          $("span.email").addClass('chk_ok bg-success');
          $("span.email").removeClass('bg-danger');
          $("span.email").text("OK")
        }
        else{
          $("span.email").addClass('bg-danger');
          $("span.email").removeClass('chk_ok bg-success');
          $("span.email").text("必須")
        }
      }
      function chk_contents(){
        if( $("textarea[name='contents']").val() != ""){
          $("span.contents").addClass('chk_ok bg-success');
          $("span.contents").removeClass('bg-danger');
          $("span.contents").text("OK")
        }
        else{
          $("span.contents").addClass('bg-danger');
          $("span.contents").removeClass('chk_ok bg-success');
          $("span.contents").text("必須")
        }
      }
        function chk_consent(){
        if( $("input[name='consent']").prop("checked")){
          $("span.consent").addClass('chk_ok bg-success');
          $("span.consent").removeClass('bg-danger');
          $("span.consent").text("OK")
        }
        else{
          $("span.consent").addClass('bg-danger');
          $("span.consent").removeClass('chk_ok bg-success');
          $("span.consent").text("必須")
        }
      }
    }
});

var headerH = $("#header").outerHeight(true);
function FixedAnime() {
	var scroll = $(window).scrollTop();
	if (scroll > headerH){
        $('#header').addClass('HeightMin');
        $('.up-btn').addClass('available');
	}
  if(scroll + 50 < headerH){
        $('#header').removeClass('HeightMin');
        $('.up-btn').removeClass('available');
	}
}

$('#btn-postal').on('click', function(){
  result.innerHTML = '通信中...';
  $.ajax({
    url: '/ajax/postal_search',
    type: 'GET',
    data:{
      first_code: $("input[name='zip01']").val(),
      last_code: $("input[name='zip02']").val(),
    },
    dataType: 'json',
    timeout: 5000,
  })
  .done(function(data) {
    result.innerHTML = '住所を入力しました';
    $("select[name='prefecture']").val(data["prefecture"]);
    if(data["address"] == '以下に掲載がない場合'){
      $("input[name='address01']").val(data["city"]);
    }
    else{
      $("input[name='address01']").val(data["city"]+data["address"]);
    }
  })
  .fail(function() {
    $("#result").addClass("text-danger");
      result.innerHTML = '郵便番号を確認してください';
  });
});

// スクロール位置調整用
function AdjustScroll(){
  let url = location.href
  if (url.split('#')[1] == null) {
    return false;
  }
  let id = "#"+url.split('#')[1];
  let headerHight = $("header").height();
  let target = $(id)

  let pos = target.offset().top - headerHight;	//idの上部の距離を取得してheader分上げる
  $('body,html').animate({scrollTop: pos}, 500);
	return false;
};

function FooterItemAjust(valid){
  let valid_info = $('#valid_info')
  let up_btn = $('#up-btn')
  let cookiePopup = $('#cookie-popup')
  let windowwidth = $(window).width()
  if(valid_info[0]&& windowwidth<1280){
    if(cookiePopup[0]&&valid){
      valid_info.css('bottom',cookiePopup.height()+'px')
    }else{
      valid_info.css('bottom','0px')
    }
  }

  if(up_btn[0]){
    if(cookiePopup[0]&&valid){
      let height = 20+cookiePopup.height()//元のclassのbottom20px分
      if(valid_info[0]){
        height += valid_info.height() + 8 //残り入力欄と被ってしまう為調整
      }
      up_btn.css('bottom',height+'px')
    }else{
      let height = 20
      if(valid_info[0]&& windowwidth<1280){
        height += valid_info.height() + 8 //残り入力欄と被ってしまう為調整
      }
      up_btn.css('bottom',height+'px')
    }
  }

}

$(window).scroll(function () {
	FixedAnime();
});

$(window).on('load', function () {
	FixedAnime();
  AdjustScroll();
  FooterItemAjust(true);
});

$(window).resize(function(){FooterItemAjust(true);});

$('#up-btn').click(function(){
  $('html, body').animate({scrollTop: 0}, 300);
});

$('[name=consent]').on('click', function () {
  if ($('[name=consent]').prop('checked')) {
      $('[type=submit]').prop('disabled', false);
  } else {
      $('[type=submit]').prop('disabled', true);
  }
});

$(function(){
  $(".cookie-policy").fadeIn();
  $(".cookie-policy-close").on('click', function() {
      $(".cookie-policy").fadeOut();
      $.ajax({
        url: '/cookie-consent',
        type: 'GET',
        timeout: 5000,
      })
      FooterItemAjust(false);
  });
});
